import React, { FunctionComponent, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { ServerPublicMetaContext, useAuthContext } from '@terragotech/gen5-shared-components';
import { getIsDisclaimerAccepted } from '../utils/utilityHelper';

interface ProtectedRouteProps {
  path: string;
  children?: React.ReactNode;
}

/**
 * ProtectedRoute Component - assists with Routing...
 *
 * The component's role is to access the AuthState using AuthContext to verify if the user is logged in or not.
 * Depending on whether authState.token exists
 *      Exists - displays prop Component, currently <AssetsDashboard />
 *      DNE - Redirects the unlogged in user to "/login"
 *
 */
const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = ({ children }) => {
  const { token, ready, loadExistingAuth } = useAuthContext();
  const {legalDisclaimer} = useContext(ServerPublicMetaContext)
  const disclaimerState = getIsDisclaimerAccepted()
  useEffect(() => {
    if (!token) {
      loadExistingAuth();
    }
  }, [token, loadExistingAuth]);

  if (!ready) return null;
  if (!token) {
    return <Redirect to="/login" />;
  }
  else if(!disclaimerState && legalDisclaimer){
    return <Redirect to="/legalDisclaimer"/>
  }
  return <>{children}</>;
};

export default ProtectedRoute;
